<template>
  <div class="tree-node">
    <div class="tree-header" @click="toggle">
      <span v-if="hasChildren">
        {{ expanded ? '▼' : '▶' }}
      </span>
      {{ node.label }}
    </div>

    <div v-if="expanded && hasChildren" class="tree-children">
      <tree-node v-for="child in node.children" :key="child.id" :node="child"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TreeNode',

  props: {
    node: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      expanded: false
    };
  },

  computed: {
    hasChildren() {
      return (this.node.children && this.node.children.length > 0);
    }
  },

  methods: {
    toggle() {
      if (this.hasChildren) {
        this.expanded = !this.expanded;
      }
    }
  }
};
</script>

<style scoped>
.tree-node {
  margin-top: 8px;
}

.tree-header {
  cursor: pointer;
  padding: 10px 15px;
  border: 1px solid #ddd;
  background: #f7f7f7;
  border-radius: 4px;
}

.tree-children {
  margin-left: 30px;
  margin-top: 8px;
  border-left: 2px solid #ddd;
  padding-left: 15px;
}
</style>
